import { dateUsaToInd, getCurrentDate, getOfficeMeta, getUserAccess } from "../frames/common";
import { useState } from "react";
import { Button, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import "./latterhead.css"
import Unauthorized from "../unauthorized";

function LetterHead() {
    const [authorized, setAuthorized] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [address, setAddress] = useState("");
    const [logo, setLogo] = useState("");
    const [name, setName] = useState("");
    const [today, setToday] = useState(false);

    if (isLoading) {
        setIsLoading(false);
        getOfficeMeta().then((res) => {
            setAddress(res["add_one_line"]);
            setLogo(res["logo"]);
            setName(res["name"]);
            return getUserAccess("LETTER_HEAD");
        }).then((auth) => {
            setAuthorized(auth);
        }).catch((err) => {
            console.error(err);
        });
    }
    if (!authorized) return <Unauthorized />; 
    return (
        <div className="latter-container">
            <style>
                {
                    `@media print {
    @page {
        size: A4;
        margin: 0;
    }

    * {
        -webkit-print-color-adjust: exact !important; /* Chrome, Edge, Safari */
        print-color-adjust: exact !important;        /* Firefox */
        color-adjust: exact !important;              /* Legacy */
    }

    .new-page {
        break-before: page;
        page-break-before: always;
        padding-top: 30mm;
    }
}`
                }
            </style>
            <div className="latterhead">
                <div className="header">
                    <table className="splitter">
                        <tbody>
                            <tr>
                                <td className="left">
                                    <span className="title">{name ?? ""}</span> <br />
                                    <span>(Authorized Channel Partner)</span>
                                </td>
                                <td className="right">
                                    <img src={logo} width={"200px"} alt="logo" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="watermark">
                    <img src="logo512.png" alt="watermark"/>
                </div>
                <div className="body">
                    <table className="splitter">
                        <tbody>
                            <tr>
                                <td className="left">
                                    Sl No: _______________
                                </td>
                                <td className="right">
                                    Date: {today ? dateUsaToInd(getCurrentDate()) : "_____ /_____ /__________"}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="print-btn">
                        <FormGroup>
                            <FormControlLabel control={<Checkbox onClick={() => { setToday(!today); }} />} label="Print current date in letter head" />
                        </FormGroup>
                        <Button variant="outlined" color="success" fullWidth onClick={() => { window.print(); }}>{address === null ? "Address Error" : "Print"}</Button>
                    </div>
                    <div className="new-page"></div>
                </div>

                <div className="footer">
                    <div style={{ fontWeight: 500 }}>DTDC Express Limited</div>
                    <div>Corporate Office: DTDC House 3, Victoria Road, Bengaluru - 560047</div>
                    <div>Channel Partner: {name ?? ""}, {address ?? ""}</div>
                    <div>dtdc.in</div>
                </div>
            </div>
        </div>
    );
}

export default LetterHead;
